import React from 'react';
import './styes/FooterPages.css';

const Terms: React.FC = () => {
  return (
    <div className="footer-page">
      <h1>Terms of Use</h1>
      <p>These terms govern your use of BuildZap. Detailed content will be added soon.</p>
      <ul>
        <li>Acceptance of terms and conditions</li>
        <li>User responsibilities and conduct</li>
        <li>Ordering, pricing, and payments</li>
        <li>Delivery, returns, and refunds</li>
        <li>Limitation of liability</li>
      </ul>
    </div>
  );
};

export default Terms;
